import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Button } from "components/ui";

import { useTranslation } from "lib/i18n/use-translation";

import styles from "./LogoutDialog.module.scss";

interface Props {
  closeLogoutDialog: (value: boolean) => void;
  closeAfterYes: () => void;
}

const LogoutDialog = ({ closeLogoutDialog, closeAfterYes }: Props) => {
  const { t } = useTranslation("common");
  const toggle = () => {
    closeLogoutDialog(false);
  };

  return (
    <Modal
      isOpen
      style={{ width: "auto", maxWidth: "400px" }}
      className={styles["modal"]}
      contentClassName={styles["modal-content"]}
      toggle={toggle}
    >
      <ModalHeader className={styles["header"]} toggle={toggle}>
        {t("common:logout.title")}
      </ModalHeader>
      <ModalBody className={styles["body"]}>
        <p>{t("common:logout.confirm")}</p>
      </ModalBody>
      <ModalFooter className={styles["footer"]}>
        <Button
          variant="enclosed-secondary"
          onClick={() => {
            closeLogoutDialog(false);
          }}
          size="small"
        >
          {t("common:action.no")}
        </Button>
        <Button
          variant="enclosed-primary"
          onClick={closeAfterYes}
          className={styles["modal-yes-button"]}
        >
          {t("common:action.yes")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default LogoutDialog;
